import { useEffect, useState, useCallback } from 'react';
import api from '../../../../../../api/api';
import useEvents from './useEvents';

export default function useShop(activeWidget) {
    if (!activeWidget.id || activeWidget?.app?.name !== 'shop') return null;
    const { emit } = useEvents();
    const [settings, setSettings] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [currencies, setCurrencies] = useState([]);

    useEffect(async () => {
        setIsLoading(true);
        try {
            const [settings, currencies] = await Promise.all([
                api.getShopSettings(activeWidget.id),
                api.getCurrenciesList()
            ]);
            setSettings(settings);
            setCurrencies(currencies);
        } catch (err) {
            emit('error', err);
        }
        setIsLoading(false);
    }, [activeWidget.id, emit]);

    const updateSettings = useCallback(async (settings) => {
        setIsLoading(true);
        try {
            await api.updateShopSettings(activeWidget.id, settings);
            setSettings((state) => {
                const updatedSettings = { ...state, ...settings };
                emit('shop.settings.updated', updatedSettings);
                return updatedSettings;
            });
            emit('shop.products.outdated');
        } catch (err) {
            emit('error', err);
        }
        setIsLoading(false);
    }, [activeWidget.id, emit]);

    return {
        id: activeWidget.id,
        settings,
        isLoading,
        currencies,
        updateSettings,
    };
}